import axios from "axios";

export const getCompanyActivities = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_company_activities"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
